import { render } from "./CourseShortCardSkeleton.vue?vue&type=template&id=22c1dc48"
import script from "./CourseShortCardSkeleton.vue?vue&type=script&lang=js"
export * from "./CourseShortCardSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__